"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runInLoop = void 0;
const promise_utils_1 = require("@api3/promise-utils");
const utils_1 = require("../utils");
const runInLoop = async (fn, options) => {
    const { logger, logLabel, frequencyMs = 0, minWaitTimeMs = 0, maxWaitTimeMs, softTimeoutMs = frequencyMs, hardTimeoutMs, enabled = true, initialDelayMs, } = options;
    if (hardTimeoutMs && hardTimeoutMs < softTimeoutMs) {
        throw new Error('hardTimeoutMs must not be smaller than softTimeoutMs');
    }
    if (minWaitTimeMs && maxWaitTimeMs && maxWaitTimeMs < minWaitTimeMs) {
        throw new Error('maxWaitTimeMs must not be smaller than minWaitTimeMs');
    }
    if (initialDelayMs)
        await (0, utils_1.sleep)(initialDelayMs);
    while (true) {
        const executionStart = performance.now();
        const executionId = (0, utils_1.generateRandomBytes32)();
        if (enabled) {
            const context = logLabel ? { executionId, label: logLabel } : { executionId };
            const shouldContinueRunning = await logger.runWithContext(context, async () => {
                logger.info('Starting execution');
                const goRes = await (0, promise_utils_1.go)(fn, hardTimeoutMs ? { totalTimeoutMs: hardTimeoutMs } : {}); // NOTE: This is a safety net to prevent the loop from hanging
                if (!goRes.success) {
                    logger.error(`Unexpected runInLoop error`, goRes.error);
                }
                const executionTimeMs = performance.now() - executionStart;
                if (executionTimeMs >= softTimeoutMs) {
                    logger.warn(`Execution took longer than the interval`, { executionTimeMs });
                }
                else {
                    logger.info(`Execution finished`, { executionTimeMs });
                }
                return goRes.data?.shouldContinueRunning === false ? false : true;
            });
            // Stop loop execution if the callback return value indicates it should stop
            if (!shouldContinueRunning) {
                break;
            }
        }
        else {
            // If the bot is disabled, we still want to run the loop to prevent the process from hanging. We also want to
            // sleep according to the wait time logic.
            logger.info('Loop execution is disabled.');
        }
        const remainingWaitTime = Math.max(frequencyMs - (performance.now() - executionStart), 0);
        const waitTime = Math.max(minWaitTimeMs, remainingWaitTime);
        const actualWaitTime = maxWaitTimeMs ? Math.min(waitTime, maxWaitTimeMs) : waitTime;
        if (actualWaitTime > 0)
            await (0, utils_1.sleep)(actualWaitTime);
    }
};
exports.runInLoop = runInLoop;
//# sourceMappingURL=index.js.map